import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ShipmentFilter = "all" | "active" | "completed";

interface ShipmentsState {
	activeButton: ShipmentFilter;
}

const initialState: ShipmentsState = {
	// What somebody opening Shipments is almost always after: what is moving.
	// "all" put finished shipments in the way of that.
	activeButton: "active",
};

const shipmentsSlice = createSlice({
	name: "shipments",
	initialState,
	reducers: {
		setActiveButton: (state, action: PayloadAction<ShipmentFilter>) => {
			state.activeButton = action.payload;
		},
	},
});

export const { setActiveButton } = shipmentsSlice.actions;
export default shipmentsSlice.reducer;
